import { render, staticRenderFns } from "./viewCommission.vue?vue&type=template&id=34ab5f7f"
import script from "./viewCommission.vue?vue&type=script&lang=js"
export * from "./viewCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports